import {marker as _} from '@biesbjerg/ngx-translate-extract-marker';
import {SearchFormComponent} from './components/searchlist/search-form/search-form.component';
import {DeviceControlComponent} from './components/searchlist/device-control/device-control.component';
import {
    CombinedInventoryInputComponent
} from './components/inputs/combined-inventory-input/combined-inventory-input.component';
import {AdminOptionsComponent} from './components/admin/admin-options/admin-options.component';

export class MenuPage {
    name: string = '';
    title: any; // ngx-translate-extract
    url: string = '';
    icon: string = '';
    hidden?: boolean;
    option?: any;  // component Type
    access?: string | string[]; // access role
}


export const appMenuPages: MenuPage[] = [
    {
        name: 'home',
        title: [_('menu.home'), _('help.page-home')], // ngx-translate-extract
        url: '/home',
        icon: 'home',
    },
    {
        name: 'deviceSingle',
        title: [_('menu.deviceSingle'), _('help.page-deviceSingle')], // ngx-translate-extract
        url: '/deviceSingle',
        icon: 'barcode',
        option: CombinedInventoryInputComponent
    },
    {
        name: 'search',
        title: [_('menu.search'), _('help.page-search')], // ngx-translate-extract
        url: '/search',
        icon: 'search',
        option: SearchFormComponent
    },
    {
        name: 'deviceList',
        title: [_('menu.deviceList'), _('help.page-deviceList')], // ngx-translate-extract
        url: '/deviceList',
        icon: 'hammer',
        hidden: true,
        option: DeviceControlComponent
    },
    {
        name: 'addDevice',
        title: [_('menu.addDevice'), _('help.page-addDevice')], // ngx-translate-extract
        url: '/addDevice',
        icon: 'add-circle-outline',
        access: ['ADMIN', 'EDIT', 'EDIT_FOREIGN']
    },
    {
        name: 'settings',
        title: [_('menu.settings'), _('help.page-settings')], // ngx-translate-extract
        url: '/settings',
        icon: 'settings',
    },
    // {
    //     name: 'special',
    //     title: _('menu.special'), // ngx-translate-extract
    //     url: '/special',
    //     icon: 'medkit',
    //     option: SpecialOptionsComponent,
    //     access: 'EDIT_FOREIGN'
    // },
    {
        name: 'admin',
        title: [_('menu.admin'), _('help.page-admin')], // ngx-translate-extract
        url: '/admin',
        icon: 'construct',
        option: AdminOptionsComponent,
        access: 'ADMIN'
    },
    {
        name: 'logout',
        title: [_('menu.logout'), _('help.page-logout')],  // ngx-translate-extract
        url: '/logout',
        icon: 'log-out',
    }
];

